var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16262",
    "data-name": "Group 16262",
    transform: "translate(-1 -1)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18974",
    "data-name": "Path 18974",
    d: "M22,1H2A1,1,0,0,0,1,2V22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V2A1,1,0,0,0,22,1ZM14,16H6.41l1.3,1.29A1,1,0,0,1,7.716,18.7l-.006.006a1,1,0,0,1-1.414.006L6.29,18.71l-3-3a1.034,1.034,0,0,1,0-1.42l3-3a1,1,0,0,1,1.42,1.42L6.41,14H14a1,1,0,0,1,0,2Zm6.92-6.62a1,1,0,0,1-.21.33l-3,3a1,1,0,0,1-1.414.006l-.006-.006a1,1,0,0,1-.006-1.414l.006-.006L17.59,10H10a1,1,0,0,1,0-2h7.59l-1.3-1.29a1,1,0,0,1,1.42-1.42l3,3a1.034,1.034,0,0,1,.21,1.09Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfers);
export default __webpack_public_path__ + "static/media/transfers.d791d50a8b59832a5c21411c3b0e7627.svg";
export { ForwardRef as ReactComponent };